import { render } from "./input-chips.vue?vue&type=template&id=3d4aeb48&scoped=true"
import script from "./input-chips.vue?vue&type=script&lang=js"
export * from "./input-chips.vue?vue&type=script&lang=js"

import "./input-chips.vue?vue&type=style&index=0&id=3d4aeb48&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3472666714/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4aeb48"]])

export default __exports__